export const scrollToTop = (behavior: ScrollBehavior = 'smooth') => {
  if (typeof window === 'undefined') return;

  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({ top: 0, behavior });
  } else {
    window.scrollTo(0, 0);
  }
};

